// src/typography.js
import { createTheme } from "@mui/material/styles";

const typography = createTheme({
    typography: {
        fontFamily: '"Poppins", sans-serif',
        // Headings
        display1: {
            fontSize: 144,
            fontWeight: 700,
            lineHeight: 1.2,
        },
        display2: {
            fontSize: 96,
            fontWeight: 700,
            lineHeight: 1.2,
        },
        display3: {
            fontSize: 64,
            fontWeight: 700,
            lineHeight: 1.2,
        },
        h1: {
            fontSize: 56,
            fontWeight: 700,
            lineHeight: 1.2,
        },
        h2: {
            fontSize: 48,
            fontWeight: 700,
            lineHeight: 1.2,
        },
        h3: {
            fontSize: 40,
            fontWeight: 700,
            lineHeight: 1.2,
        },
        h4: {
            fontSize: 32,
            fontWeight: 700,
            lineHeight: 1.2,
        },
        h5: {
            fontSize: 32,
            fontWeight: 600,
            lineHeight: 1.2, // Changed from "auto" to 1.2
        },
        // Body
        heroBold: {
            fontSize: 28,
            fontWeight: 700,
            lineHeight: 1.2,
        },
        heroAccent: {
            fontSize: 28,
            fontWeight: 600,
            lineHeight: 1.2,
        },
        heroEmphasis: {
            fontSize: 28,
            fontWeight: 400,
            fontStyle: "italic",
            lineHeight: 1.2,
        },
        heroStandard: {
            fontSize: 28,
            fontWeight: 400,
            lineHeight: 1.2,
        },
        featureBold: {
            fontSize: 24,
            fontWeight: 700,
            lineHeight: 1.2,
        },
        featureAccent: {
            fontSize: 24,
            fontWeight: 600,
            lineHeight: 1.2,
        },
        featureEmphasis: {
            fontSize: 24,
            fontWeight: 400,
            fontStyle: "italic",
            lineHeight: 1.2,
        },
        featureStandard: {
            fontSize: 24,
            fontWeight: 400,
            lineHeight: 1.2,
        },
        highlightBold: {
            fontSize: 18,
            fontWeight: 700,
            lineHeight: 1.2,
        },
        highlightSemibold: {
            fontSize: 18,
            fontWeight: 600,
            lineHeight: 1.2,
        },
        highlightEmphasis: {
            fontSize: 18,
            fontWeight: 400,
            fontStyle: "italic",
            lineHeight: 1.2,
        },
        highlightStandard: {
            fontSize: 18,
            fontWeight: 400,
            lineHeight: 1.2,
        },
        contentBold: {
            fontSize: 16,
            fontWeight: 700,
            lineHeight: 1.2,
        },
        contentAccent: {
            fontSize: 16,
            fontWeight: 600,
            lineHeight: 1.2,
        },
        contentEmphasis: {
            fontSize: 16,
            fontWeight: 500,
            lineHeight: 1.2, // Changed from "auto" to 1.2
        },
        contentRegular: {
            fontSize: 16,
            fontWeight: 400,
            lineHeight: 1.2,
        },
        captionBold: {
            fontSize: 14,
            fontWeight: 700,
            lineHeight: 1.2,
        },
        captionAccent: {
            fontSize: 14,
            fontWeight: 600,
            lineHeight: 1.2,
        },
        captionEmphasis: {
            fontSize: 14,
            fontWeight: 500,
            lineHeight: 1.2, // Changed from "auto" to 1.2
        },
        captionRegular: {
            fontSize: 14,
            fontWeight: 400,
            lineHeight: 1.2,
        },
        supportBold: {
            fontSize: 12,
            fontWeight: 700,
            lineHeight: 1.2,
        },
        supportAccent: {
            fontSize: 12,
            fontWeight: 600,
            lineHeight: 1.2,
        },
        supportEmphasis: {
            fontSize: 12,
            fontWeight: 500,
            lineHeight: 1.2, // Changed from "auto" to 1.2
        },
        supportRegular: {
            fontSize: 12,
            fontWeight: 400,
            lineHeight: 1.2,
        },
    },
});

export default typography;
